





























































































import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import anime from "animejs";
import { Route } from "vue-router";
import ContentContainer from "../../components/ContentContainer.vue";
import NumberedLine from "../../components/NumberedLine.vue";
import Map from "../../components/Map.vue";
import CallOrderForm from "../../components/forms/CallOrderForm.vue";
import SocialLinks from "../../components/SocialLinks.vue";

@Component({
  components: {
    ContentContainer,
    CallOrderForm,
    SocialLinks
  }
})
export default class ObjectPageContacts extends Vue {
  @Prop() visibleScreenNumber!: number;
  @Prop() activeScreenNumber!: number;
  @Prop() screenNumber!: number;
  @State(state => state.app.loadingScreenAnimationEnded)
  loadingAnimationEnded!: boolean;
  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;

  $refs!: {
    screen: HTMLElement;
  };

  @Emit("change-screen")
  changeScreen() { }

  get screenHeight() {
    return this.$browser.height < 350 ? 350 : this.$browser.height;
  }

  get containerHeight() {
    let height = this.scrollingByScreens
      ? this.screenHeight - 130
      : this.screenHeight - 30;
    return height;
  }

  /**************************************/
  /************* Анимации ***************/
  /**************************************/

  alreadyEntered = false;

  /** Предыдущий экран уходит.*/
  @Watch("activeScreenNumber")
  activeScreenNumberChange(nextNumber: number, prevNumber: number) {
    if (prevNumber == this.screenNumber && this.scrollingByScreens) {
      this.screenLeave();
    }
  }

  /** Следующий экран появляется*/
  @Watch("visibleScreenNumber")
  visibleScreenNumberChange(nextNumber: number, prevNumber: number) {
    if (
      nextNumber == this.screenNumber &&
      (this.scrollingByScreens || !this.alreadyEntered)
    ) {
      this.screenEnter(prevNumber);
      this.alreadyEntered = true;
    }

    if (nextNumber == this.screenNumber) {
      localStorage.setItem("screen", "Как с нами связаться");
    }
  }

  /** Появление */
  screenEnter(prevScreenNumber: number) {
    if (this.scrollingByScreens) {
      let title = this.$refs.screen.querySelector(".contacts-screen___title");
      let form = this.$refs.screen.querySelector(
        ".contacts-screen___form"
      );
      let firstColumnItems = this.$refs.screen.querySelectorAll<HTMLElement>(
        ".contacts-screen___content-row > div:nth-child(1) .contacts-screen___contacts-item, .social-links"
      );

      let secondColumnItems = this.$refs.screen.querySelectorAll<HTMLElement>(
        ".contacts-screen___content-row > div:nth-child(2) .contacts-screen___contacts-item"
      );

      anime({
        targets: title,
        duration: 500,
        opacity: [0, 1],
        easing: "easeOutQuad"
      });

      anime({
        targets: form,
        duration: 1000,
        opacity: [0, 1],
        translateX: ["-105%", "0%"],
        easing: "easeOutQuad",
        delay: 600
      });

      anime({
        targets: firstColumnItems,
        duration: 1000,
        opacity: [0, 1],
        translateX: ["-100%", "0%"],
        easing: "easeOutQuad",
        delay: 100
      });

      anime({
        targets: secondColumnItems,
        duration: 1000,
        opacity: [0, 1],
        translateX: ["-100%", "0%"],
        easing: "easeOutQuad",
        delay: 350
      });
    }
  }

  /** Исчезание */
  screenLeave() {
    if (this.scrollingByScreens) {
      let title = this.$refs.screen.querySelector(".contacts-screen___title");
      let form = this.$refs.screen.querySelector(
        ".contacts-screen___form"
      );
      let firstColumnItems = this.$refs.screen.querySelectorAll<HTMLElement>(
        ".contacts-screen___content-row > div:nth-child(1) .contacts-screen___contacts-item, .social-links"
      );

      let secondColumnItems = this.$refs.screen.querySelectorAll<HTMLElement>(
        ".contacts-screen___content-row > div:nth-child(2) .contacts-screen___contacts-item"
      );

      anime({
        targets: title,
        duration: 500,
        opacity: [1, 0],
        easing: "easeOutQuad"
      });

      anime({
        targets: form,
        duration: 700,
        opacity: [1, 0],
        translateX: ["0%", "30%"],
        easing: "easeOutQuad",
        delay: 0
      });

      anime({
        targets: firstColumnItems,
        duration: 700,
        opacity: [1, 0],
        translateX: ["0%", "30%"],
        easing: "easeOutQuad",
        delay: 400
      });

      anime({
        targets: secondColumnItems,
        duration: 700,
        opacity: [1, 0],
        translateX: ["0%", "30%"],
        easing: "easeOutQuad",
        delay: 200
      });
    }

    setTimeout(() => {
      this.changeScreen();
    }, 1000);
  }
}
